import { useEffect, useState } from 'react';

/** How long text must stop growing to count as done. Longer than the normal gap between tokens. */
const TEXT_IDLE_MS = 800;

/**
 * True once `text` stops changing during an active run. There's no "text finished" event — `result`
 * arrives only after citation validation.
 */
export const useIsStreamedTextIdle = (text: string, isRunActive: boolean): boolean => {
  // Stores the text the timer last saw, so new text is automatically "not idle" without a reset.
  const [textIdleSince, setTextIdleSince] = useState<string | null>(null);

  useEffect(() => {
    if (!isRunActive) return;

    const timer = setTimeout(() => setTextIdleSince(text), TEXT_IDLE_MS);
    return () => clearTimeout(timer);
  }, [text, isRunActive]);

  return isRunActive && textIdleSince === text;
};
